import { profileContactInfoPages } from 'platform/forms-system/src/js/patterns/prefill';
import { getContent } from 'platform/forms-system/src/js/utilities/data/profile';

const claimantContactInformation = profileContactInfoPages({
  content: getContent('application'),
  contactInfoPageKey: 'yourContactInformation',
  contactPath: 'your-contact-information',
  wrapperKey: 'yourContactInformation',
  addressKey: 'mailingAddress',
  homePhoneKey: 'homePhone',
  mobilePhoneKey: 'mobilePhone',
  emailKey: 'email',
  included: ['mailingAddress', 'mobilePhone', 'homePhone', 'email'],
  contactInfoRequiredKeys: ['mailingAddress', 'email'],
  prefillPatternEnabled: true,
  showProfileAlert: true,
  // TODO(phase 2): remove depends after survivors_benefits_updated_prefill is 100% in prod
  depends: formData => formData?.survivorsBenefitsUpdatedPrefill === true,
  // Read contact info from profile.vapContactInfo (sourced from the user.json
  // vet360_contact_information mock) rather than the platform generateMockUser
  // canned data, so the contact card stays consistent with the prefilled
  // personal info.
  disableMockContactInfo: true,
});

export default claimantContactInformation;
